import { useState } from 'react';
import { TreePine } from 'lucide-react';

// ─── Das Wappen eines Stammbaums ─────────────────────────────────────────────
//
// Überall dort, wo bisher das Nadelbaum-Symbol stand: im Umschalter, in der
// Liste der Bäume. Wer keins hinterlegt hat, behält den Baum – ein leerer
// Platzhalter wäre schlechter als ein Symbol, das immerhin sagt, worum es geht.
//
// Fällt das Bild aus (gelöschte Datei, abgelaufene Sitzung, kein Medien-Cookie),
// erscheint ebenfalls der Baum. Ein zerbrochenes Bildsymbol in der Kopfzeile
// sähe nach einem Fehler der Anwendung aus, und der Nutzer könnte nichts damit
// anfangen.

interface WappenProps {
  url: string | null | undefined;
  /** Kantenlänge in Tailwind-Einheiten – 4 = 1rem. */
  groesse?: 4 | 5 | 6 | 8 | 12 | 16 | 24;
  className?: string;
}

const KLASSEN: Record<number, string> = {
  4: 'h-4 w-4',
  5: 'h-5 w-5',
  6: 'h-6 w-6',
  8: 'h-8 w-8',
  12: 'h-12 w-12',
  16: 'h-16 w-16',
  24: 'h-24 w-24',
};

export function Wappen({ url, groesse = 4, className = '' }: WappenProps) {
  const [kaputt, setKaputt] = useState(false);
  const masse = KLASSEN[groesse];

  if (!url || kaputt) {
    return (
      <TreePine
        className={`${masse} shrink-0 text-emerald-600 ${className}`}
        aria-hidden="true"
      />
    );
  }

  return (
    <img
      src={url}
      alt=""
      // object-contain, nicht cover: ein Wappen ist selten quadratisch, und ein
      // beschnittener Helm ist schlimmer als ein Rand.
      className={`${masse} shrink-0 rounded object-contain ${className}`}
      onError={() => setKaputt(true)}
    />
  );
}
